module.exports = __webpack_public_path__ + "img/Kitchen.25220674.jpg";